import { Component } from '@angular/core';
import { ClevertapService } from '../../../service/clevertap.service';
import { TranslatePipe } from '@ngx-translate/core';
import { CarInsuranceFooterComponent } from '../car-insurance-footer/car-insurance-footer.component';
import { CarInsuranceNavbarComponent } from '../car-insurance-navbar/car-insurance-navbar.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-car-insurance-success-page',
  standalone: true,
  imports: [CarInsuranceNavbarComponent, CarInsuranceFooterComponent, TranslatePipe, CommonModule],
  templateUrl: './car-insurance-success-page.component.html',
  styleUrl: './car-insurance-success-page.component.scss'
})
export class CarInsuranceSuccessPageComponent {
  // ✅ Add this property
  showBottomSheet: boolean = true;


  // Injecting ClevertapService into the component via constructor dependency injection
  constructor(private clevertapService: ClevertapService) { }

  // ngOnInit is a lifecycle hook in Angular
  ngOnInit(): void {
    const productType = 'car_insurance'; // dynamic based on route or API

    // Adding a delay to ensure the campaign trigger catch is reliable after route change
    setTimeout(() => {
      this.clevertapService.trackEvent('explored_after_submission', {
        product_type: productType
      });
      // Show notification prompt fallback if not already subscribed
      this.clevertapService.showNotificationPrompt();
    }, 1000);
  }


  // ✅ Add this function
  hideBottomSheet() {
    if (this.showBottomSheet) {
      this.showBottomSheet = false;
    }
  }

}
